<template>
	<div class="content-wrapper">
		<!-- Content -->

		<div class="container flex-grow-1 container-p-y">
			<div class="spinner-border spinner-border-lg text-primary load-center" role="status" v-if="isLoading">
				<span class="visually-hidden">Loading...</span>
			</div>

			<div class="col-md-12 mb-5">
				<div class="card h-100">
					<div class="card-body pb-4">
						<div class="mb-0">
							<div class="d-flex align-items-center">
								<div class="avatar avatar-md">
									<div class="avatar-initial bg-label-primary rounded-3">
										<i class="ri-bank-card-line ri-24px"></i>
									</div>
								</div>
								<div class="ms-4">
									<p class="mb-0">
										{{ $t('purchaseCredits.contactInfo') }}
									</p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="col-xl-12 mb-5">
				<div class="card">
					<h5 class="card-header">{{ $t('purchaseCredits.choosePack') }}</h5>

					<div class="card-body">
						<div class="row">
							<div class="col-md mb-md-0 mb-5">
								<div class="form-check custom-option custom-option-basic">
									<label class="form-check-label custom-option-content" for="customRadioTemp1">
									<input
										name="customRadioTemp-1"
										v-model="pack"
										class="form-check-input"
										type="radio"
										value="5"
										id="customRadioTemp1"
										@change="selectPack"
										/>
									<span class="custom-option-header">
										<span class="h6 mb-0">{{ $t('purchaseCredits.credits5') }}</span>
										<small class="text-muted">{{ $t('purchaseCredits.price5') }}</small>
									</span>
									</label>
								</div>
							</div>
							<div class="col-md mb-md-0 mb-5">
								<div class="form-check custom-option custom-option-basic">
									<label class="form-check-label custom-option-content" for="customRadioTemp2">
									<input
										name="customRadioTemp-1"
										v-model="pack"
										class="form-check-input"
										type="radio"
										value="50"
										id="customRadioTemp2"
										@change="selectPack"
										/>
									<span class="custom-option-header">
										<span class="h6 mb-0">{{ $t('purchaseCredits.credits50') }}</span>
										<small class="text-muted">{{ $t('purchaseCredits.price50') }}</small>
									</span>
									</label>
								</div>
							</div>
							<div class="col-md mb-md-0 mb-5">
								<div class="form-check custom-option custom-option-basic">
									<label class="form-check-label custom-option-content" for="customRadioTemp3">
									<input
										name="customRadioTemp-1"
										v-model="pack"
										class="form-check-input"
										type="radio"
										value="100"
										id="customRadioTemp3"
										@change="selectPack"
										/>
									<span class="custom-option-header">
										<span class="h6 mb-0">{{ $t('purchaseCredits.credits100') }}</span>
										<small class="text-muted">{{ $t('purchaseCredits.price100') }}</small>
									</span>
									</label>
								</div>
							</div>
							<div class="col-md mb-md-0 mb-5">
								<div class="form-check custom-option custom-option-basic">
									<label class="form-check-label custom-option-content" for="customRadioTemp4">
									<input
										name="customRadioTemp-1"
										v-model="pack"
										class="form-check-input"
										type="radio"
										value="200"
										id="customRadioTemp4"
										@change="selectPack"
										/>
									<span class="custom-option-header">
										<span class="h6 mb-0">{{ $t('purchaseCredits.credits200') }}</span>
										<small class="text-muted">{{ $t('purchaseCredits.price200') }}</small>
									</span>
									</label>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="col-md">
				<div class="card mb-2">
					<h5 class="card-header">{{ $t('purchaseCredits.requestedCredits') }}</h5>
					<div class="card-body">
						<div class="form-floating form-floating-outline">
							<input
								type="number"
								class="form-control"
								id="floatingInput"
								v-model="requestedCredits"
								placeholder="10"
								aria-describedby="floatingInputHelp"
								@input="selectCredits" />
							<label for="floatingInput">{{ $t('purchaseCredits.requestedCredits') }}</label>
						</div>
						<p style="text-align: center;" class="pt-5">
							{{ $t('purchaseCredits.total', { price: price.toLocaleString('fr-FR') }) }}
						</p>
					</div>
				</div>
			</div>


			<div class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-6 row-gap-4">
				<div class="d-flex flex-column justify-content-center">
					
				</div>
				<div class="d-flex align-content-center flex-wrap gap-4 mt-5">
					<router-link to="/transactions">
						<button class="btn btn-outline-secondary">{{ $t('common.actions.back') }}</button>
					</router-link>
					<button type="submit" class="btn btn-primary" @click="purchaseCredits()" v-if="!isWaitingStripe">{{ $t('common.actions.pay') }}</button>

					<button class="btn btn-primary waves-effect waves-light" type="button" disabled="" v-if="isWaitingStripe">
						<span class="spinner-border me-1" role="status" aria-hidden="true"></span>
						{{ $t('common.loading') }}
					</button>
				</div>
			</div>

		</div>
		<!-- / Content -->
		<div class="content-backdrop fade"></div>
	</div>
</template>

<script>
import HTTP from "@/axios";
import moment from "moment";
import "moment/locale/fr";

moment.locale(localStorage.getItem('locale') || 'fr');

export default {
	name: "PurchaseCreditsPage",

	data() {
		return {
			pack: null,
			requestedCredits: null,
			price: 0,
			isLoading: false,
			isWaitingStripe: false,
			company: null,
		};
	},

	methods: {
		selectPack() {
			this.requestedCredits = this.pack;
			this.calculatePrice();
		},

		selectCredits() {
			this.calculatePrice();
		},

		calculatePrice() {
			if (!this.requestedCredits)
				return;

			this.price = (5 * this.requestedCredits);
		},

		async fetchCompany() {
			try {
				const response = await HTTP('/company');
				this.company = response.data.company;
			} catch (error) {
				// Récupérer le message d'erreur de l'API ou définir un message par défaut
				const errorMessage = error?.response?.data?.message || this.$t('errors.generic');

				alert(errorMessage);

				// Log détaillé dans la console (utile en développement)
				console.error("Erreur API:", error);
			}
		},

		async purchaseCredits() {
			if (!this.requestedCredits)
				return;

			if (this.requestedCredits < 1)
				return;

			this.isWaitingStripe = true;

			try {
				const rep = await HTTP.post('/company/purchase-credits', {
					requestedCredits: this.requestedCredits,
				});

				window.location.replace(rep.data.url);
			} catch (error) {
				// Récupérer le message d'erreur de l'API ou définir un message par défaut
				const errorMessage = error?.response?.data?.message || this.$t('errors.generic');

				alert(errorMessage);

				// Log détaillé dans la console (utile en développement)
				console.error("Erreur API:", error);
			}
		}
	},

	async mounted() {
		this.fetchCompany();
	}
};
</script>

<style scoped>
/* Ajoutez des styles spécifiques à la page Dashboard */
.dashboard {
	padding: 1rem;
}

.card-title {
	font-size: 1.2rem;
}

.card-text {
	margin: 0;
}

.load-center {
	display: block;
	margin: 0 auto;
}
</style>
